import ApiAdapter from '../adapters/ApiAdapter'
import { LOGIN_USER, LOGOUT_USER, DELETE_USER, DELETE_TABLE, DELETE_CUPPING } from '../actions/types'

export const loginUserAuth = (data) => {
    return {type: LOGIN_USER,  payload: data}
}

export const logoutUser = () => {
    return {type: LOGOUT_USER}
}


export const loginUser = (name, uid, image_src, provider) => {
    return ApiAdapter.userPostOrFind(name, uid, image_src, provider)
}

export const fetchUser = (token) => {
    return ApiAdapter.fetchCurrentUser(token)
}

export const updateUser = (name, imgSrc, bio, userId) => {
    return ApiAdapter.updateUser(name, imgSrc, bio, userId)
}

export const newTable = (table, userId, userName) => {
    return ApiAdapter.postTable(table, userId, userName)
}

export const fetchLatestCuppings = () => {
    return ApiAdapter.fetchLatestCuppings()
}

export const fetchUserTables = (userID) => {
    return ApiAdapter.fetchUserTables(userID)
}

export const fetchAnotherUser = (anotherUserId) => {
    return ApiAdapter.fetchAnotherUser(anotherUserId)
}

export const getUserTableCuppings = (tableId) => {
    return ApiAdapter.fetchUsrTableCuppings(tableId)
  }

export const fetchSingleUsrTable = (tableId) => {
    return ApiAdapter.fetchSingleUsrTable(tableId)
}

export const fetchSingleCupping = (cuppingId) => {
    return ApiAdapter.fetchSingleCupping(cuppingId)
}

export const updateCupping = (cupping, cuppingId) => {
    return ApiAdapter.updateCupping(cupping, cuppingId)
  }
  
export const updateTable = (table, tableId) => {
    return ApiAdapter.updateTable(table, tableId)
}

export const deleteUser = (userId) => {
    return ApiAdapter.deleter("catadors", userId, DELETE_USER)
}

export const deleteTable = (tableId) => {
    return ApiAdapter.deleter("tables", tableId, DELETE_TABLE)
}

export const deleteCupping = (cuppingId) => {
    return ApiAdapter.deleter("cuppings", cuppingId, DELETE_CUPPING)
}

export const generateProfilePath = (id) => {
    // adding +391+ for added encoding strength
    const profilePath = window.btoa(`${id}+391+`)
    return profilePath
}

export const getProfileId = (path) => {
    const profileId = window.atob(path)
    return profileId
}

export const isOwner = (userId, tableUserId) => {
    if (userId === tableUserId) {
        return true
    } else {
        return false
    }
}
